import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { CommonButton } from '@/components/ui/common-button';

const VerifyRequestDialog = ({ open, onOpenChange, submitting, onSubmit }) => {
  const [verificationNotes, setVerificationNotes] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(verificationNotes);
  };

  return (
    <Dialog open={open} onOpenChange={(val) => {
      if (!val) setVerificationNotes('');
      onOpenChange(val);
    }}>
      <DialogContent className="sm:max-w-[400px]">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle className="text-lg font-bold text-foreground">Verify Edit Request</DialogTitle>
          </DialogHeader>

          <div className="py-4 space-y-3">
            <label className="text-sm font-semibold text-foreground">Verification Notes (Optional)</label>
            <textarea
              value={verificationNotes}
              onChange={(e) => setVerificationNotes(e.target.value)}
              placeholder="e.g. Checked with weighbridge operator..."
              className="w-full bg-background border border-border rounded-lg p-2.5 text-sm min-h-[80px] outline-none focus:border-primary text-foreground"
            />
          </div>

          <DialogFooter className="flex justify-end gap-2">
            <CommonButton 
              type="button" 
              variant="outline" 
              onClick={() => onOpenChange(false)} 
              disabled={submitting}
              className="w-32"
            >
              Cancel
            </CommonButton>
            <CommonButton 
              type="submit" 
              variant="default" 
              loading={submitting}
              className="w-32 bg-emerald-600 hover:bg-emerald-700 text-white font-medium"
            >
              Confirm Verify
            </CommonButton>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default VerifyRequestDialog;
